import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const BASE_URL = "https://tradewater.co/wp-content/themes/tradewater/widget/api/public"
//const BASE_URL = "/wp-content/themes/tradewater/widget/api/public"
export default {
  getAutocompleteAirports: (term)=>
    axios.get(`${BASE_URL}/airports/${term}`),
  getAutocompletePlaces: (term)=>{
    let token = sessionStorage.getItem('mapToken')
    if(!token){
      token = uuidv4()
      sessionStorage.setItem('mapToken', token)
    } 
    return axios.post(`${BASE_URL}/places`, {
      term, token
    })
  },
  getDistance: (origin, destination)=>
    axios.post(`${BASE_URL}/driving`,{
      origin, destination
    }),
  getLodgingEmissions: (nights, rooms)=>
    axios.get(`${BASE_URL}/lodging/${nights}/${rooms}`),
  getDefault: ()=>
    axios.get(`${BASE_URL}/default`),
  calculate: (data)=>
    axios.post(`${BASE_URL}/calculate`, data), 
}